export enum MessageBeforeManuallyAddPartActionsEnum {
  USE_EXISTING_PART = "USE_EXISTING_PART",
  CREATE_PART = "CREATE_PART"
}
